module.exports = "<h1 class=\"page-title\">Page Title </h1>\n<p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/directives/pageintro/pageintro.html
// module id = 80
// module chunks = 0